module.exports = {
    trackMyOrderEta: {
        disclaimer: '',
        googleMapApiUrl: '',
        googleMapsEnabled: true,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/track-my-order-eta.js